import component from './listings.vue'

export default component
